import { render, staticRenderFns } from "./SectionContentsList.vue?vue&type=template&id=46052421&"
import script from "./SectionContentsList.vue?vue&type=script&lang=js&"
export * from "./SectionContentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports